var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTelestration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .telestration_a {\n                fill: none !important;\n            }\n\n            .telestration_b {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "telestration_a",
    width: 44,
    height: 44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.307 6.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "telestration_b",
    d: "M105.523,720.813l-6.4-6.4a1.4,1.4,0,0,0-1.974,0L73,738.555v6.982a1.4,1.4,0,0,0,1.4,1.4h6.981l24.145-24.145A1.4,1.4,0,0,0,105.523,720.813Zm-29.73,18.9,22.34-22.338,4.428,4.427-22.342,22.34H75.792Z",
    transform: "translate(-73 -714)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTelestration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_telestration.1d6fc63e4a3706ef7dc331c9bc156813.svg";